export default __webpack_public_path__ + "static/media/siren.d99717c9.mp3";